export const chartOptions = {
  chart: {
    type: 'bar',
    height: 350
  },
  plotOptions: {
    bar: {
      distributed: true,
      borderRadius: 4,
      horizontal: true
    }
  },
  colors: [
    '#6dd2ff',
    '#ff9933',
    '#13d8aa',
    '#ffff00',
    '#f9a3a4',
    '#2b908f',
    '#ff33cc'
  ],

  dataLabels: {
    enabled: true,
    offsetX: 0,
    style: {
      fontSize: '12px',
      colors: ['#000']
    },
    formatter: function(val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true
  },

  xaxis: {
    categories: []
  },
  tooltip: {
    theme: 'light',
    x: {
      show: true
    },
    y: {
      title: {
        formatter: function() {
          return ''
        }
      }
    }
  }
  /*   title: {
    text: 'Gráfico 1',
    align: 'center'
  } */
}
export const chartOptions2 = {
  chart: {
    height: 300,
    type: 'line',
    zoom: {
      enabled: false
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    curve: 'straight',
    width: 2
  },
  title: {
    text: '',
    align: 'center',
    style: {
      fontSize: '15px',
      fontWeight: 'bold',
      fontFamily: undefined,
      color: '#000'
    }
  },
  subtitle: {
    text: '',
    align: 'center',
    margin: 10,
    offsetX: 0,
    offsetY: 25,
    floating: false,
    style: {
      fontSize: '15px',
      fontWeight: 'bold',
      fontFamily: undefined,
      color: '#000'
    }
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      opacity: 0.5
    }
  },
  xaxis: {
    categories: []
    // type: 'category'
  },
  yaxis: {
    min: 0
    // max: 100
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center'
  },
  markers: {
    size: 5
  },
  colors: [
    '#008FFB',
    '#ff9933',
    '#FF0000',
    '#009933',
    '#ffff00',
    '#000000',
    '#ff33cc'
  ]
}
export const chartOptions3 = {
  chart: {
    height: 300,
    type: 'line',
    zoom: {
      enabled: false
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    curve: 'straight',
    width: 2
  },
  title: {
    text: '',
    align: 'center',
    style: {
      fontSize: '15px',
      fontWeight: 'bold',
      fontFamily: undefined,
      color: '#000'
    }
  },
  subtitle: {
    text: '',
    align: 'center',
    margin: 10,
    offsetX: 0,
    offsetY: 25,
    floating: false,
    style: {
      fontSize: '15px',
      fontWeight: 'bold',
      fontFamily: undefined,
      color: '#000'
    }
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      opacity: 0.5
    }
  },
  xaxis: {
    categories: []
    // type: 'category'
  },
  yaxis: {
    min: 0
    // max: 100
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center'
  },
  markers: {
    size: 5
  },
  colors: [
    '#008FFB',
    '#ff9933',
    '#FF0000',
    '#009933',
    '#ffff00',
    '#000000',
    '#ff33cc'
  ]
}
